<template>
  <div class="inline-block relative">
    <div :class="classes" v-if="modelValue">{{ modelValue }}</div>
    <slot></slot>
  </div>
</template>

<script setup>
  const props = defineProps({
    modelValue: [String, Number],
  })
  const classes =
    'absolute left-full -ml-2 bottom-full -mb-3 bg-blue-500 text-white size-4 rounded-full text-xs'
</script>

<style></style>
